import { AnalyticsActionTypes, AnalyticsState } from '../../constants/Analytics';

export const initialState: AnalyticsState = {
  filters: null,
  filterLoaded: false,
  currentFilter: null,
  list: { items: [], count: 0, page: 1, perPage: 50, loading: false },
  aggregate: { rows: [], bins: [], groupBy: [], dedupe: 'latest', loading: false },
  error: null,
};

export default function analytics(state = initialState, action: any): AnalyticsState {
  switch (action.type) {
    case AnalyticsActionTypes.SET_FILTER:
      return { ...state, currentFilter: action.filter };
    case AnalyticsActionTypes.START_FILTERS:
      return { ...state, error: null };
    case AnalyticsActionTypes.FINISH_FILTERS:
      return { ...state, filters: action.filters, filterLoaded: true };
    case AnalyticsActionTypes.START_SEARCH:
      return { ...state, list: { ...state.list, loading: true }, error: null };
    case AnalyticsActionTypes.FINISH_SEARCH:
      return {
        ...state,
        list: {
          items: action.payload.items,
          count: action.payload.count,
          page: action.payload.page,
          perPage: action.payload.perPage,
          loading: false,
        },
      };
    case AnalyticsActionTypes.START_AGGREGATE:
      return { ...state, aggregate: { ...state.aggregate, loading: true }, error: null };
    case AnalyticsActionTypes.FINISH_AGGREGATE:
      return {
        ...state,
        aggregate: {
          rows: action.payload.rows,
          bins: action.payload.bins,
          groupBy: action.payload.groupBy,
          dedupe: action.payload.dedupe,
          loading: false,
        },
      };
    case AnalyticsActionTypes.API_ERROR:
      return {
        ...state,
        error: action.error,
        list: { ...state.list, loading: false },
        aggregate: { ...state.aggregate, loading: false },
      };
    default:
      return state;
  }
}
